module.exports = {
    'API_URL': 'https://core.bigplay.gg/',
}
